export default __webpack_public_path__ + "static/media/microsoft.034016b2.svg";